<app-modal #modalComponent>
   <div class=" h-screen w-screen z-50 top-0 left-0 lg:hidden ">
    <div class="relative w-full h-full bg-blue-500">

       <div class="title">
        <div class="pt-3">
            <div class="flex p-2">
                <svg (click)="close()" class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
                <div class=""></div>
            </div>

        <svg *ngIf="!loading && !error" class="w-16 h-16 text-center m-auto mb-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path></svg>
        <app-loader *ngIf="loading && !error"></app-loader>
        <svg *ngIf="error" class="w-20 h-20 text-center m-auto mb-5 text-red-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
    </div>
        <p class="text-2xl text-center text-white mb-5 ">{{title}}</p>
       </div> 
       
       <div class=" absolute bottom-12 w-full">
        <p class="mb-3  text-center {{error?'text-red-200':'text-white'}}">{{message}}</p>

        <div class="dots flex justify-around bg-blue-400 p-6 m-3 rounded-md mb-8 ">
            <div  class="dot p-5 rounded-md bg-blue-500 text-white">
                <div  class="rounded-full h-4 w-4 {{pin.length >= 1?'bg-white':'bg-blue-500'}}"></div>
            </div>
            <div  class="dot p-5 rounded-md bg-blue-500 text-white">
                <div class="rounded-full h-4 w-4 {{pin.length >= 2?'bg-white':'bg-blue-500'}}"></div>
            </div>
            <div  class="dot p-5 rounded-md bg-blue-500 text-white">
                <div class="rounded-full h-4 w-4 {{pin.length >= 3?'bg-white':'bg-blue-500'}}"></div>
            </div>
            <div  class="dot p-5 rounded-md bg-blue-500 text-white">
                <div class="rounded-full h-4 w-4 {{pin.length >= 4?'bg-white':'bg-blue-500'}}"></div>
            </div>
       </div>
       <div class="key-pad grid grid-cols-3 gap-2 p-3 align-middle justify-center">
        <button (click)="concatPin('1')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            1
        </button>
        <button (click)="concatPin('2')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            2
        </button>
        <button (click)="concatPin('3')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            3
        </button>
        <button (click)="concatPin('4')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            4
        </button>
        <button (click)="concatPin('5')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            5
        </button>
        <button (click)="concatPin('6')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            6
        </button>
        <button (click)="concatPin('7')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            7
        </button>
        <button (click)="concatPin('8')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            8
        </button>
        <button (click)="concatPin('9')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            9
        </button>
        <button (click)="concatPin('')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            *
        </button>
        <button (click)="concatPin('0')" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            0
        </button>
        <button (click)="deleteChar()" class="key rounded-lg p-5 text-center text-white text-4xl bg-blue-400 hover:bg-blue-400">
            <svg class="w-10 h-10 m-auto text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"></path></svg>
        </button>
       </div>
       </div>
   </div>
</div>


<!-- large screen -->
<div class="hidden lg:block text-center">
    <div class="flex p-3">
        <svg (click)="close()" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
        <div class=""></div>
    </div>
    <svg *ngIf="!loading && !error" class="w-10 h-10 text-center m-auto mb-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path></svg>
    <app-loader *ngIf="loading && !error"></app-loader>
    <svg *ngIf="error" class="w-10 h-10 text-center m-auto mb-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
    <p class="text-2xl text-center mb-3 ">{{title}}</p>
    <p class="mb-3  text-center {{error?'text-red-400':''}}">{{message}}</p>
    <input [disabled]="pin.length > 4" type="password" (keyup)="concatPin('')" class="input-field w-60 m-auto    text-2xl mb-4 box-border" name="pin" [(ngModel)]="pin" id="pin">
</div>
</app-modal>
